import { trans } from '@spotahome/soyuz/client';

import HeartLockIcon from '@spotahome/ui-library/src/tenant/components/icons/HeartLockIcon';

import './LogoText.scss';

const LogoText = () => {
  return (
    <div className="tenant-guarantees-logo">
      <HeartLockIcon />
      <span className="tenant-guarantees-logo__text">
        {trans('tenant_guarantees.hero.spotahome.guarantee')}
      </span>
    </div>
  );
};

export default LogoText;
